'use strict'

/**
 * Composant Panier Vendeur pour le panier
 */

import progressbar from 'Components/progressbar'

export default Vue.component('modzpaniervendeur', {
    props: ['paniervendeur'],
    components: {
        progressbar
    },
    computed: {
        promotion() {
            var promotions = this.paniervendeur.Transports.flatMap(
                (x) => x.Promotions
            )

            if (promotions == null || promotions.length == 0) {
                return null
            }

            promotions.sort((a, b) => {
                if (a.MontantFraisDePortTtc > b.MontantFraisDePortTtc) return 1
                if (a.MontantFraisDePortTtc < b.MontantFraisDePortTtc) return -1

                if (
                    a.SeuilRestantPromotionAvailable >
                    b.SeuilRestantPromotionAvailable
                )
                    return 1
                if (
                    a.SeuilRestantPromotionAvailable <
                    b.SeuilRestantPromotionAvailable
                )
                    return -1
            })

            var promotion = promotions[0]

            if (promotion.Pourcentage >= 100) return

            return promotion
        },
        nombreProduit() {
            var nb = this.paniervendeur.LignesPaniers.filter(
                (x) => !x.IsProduitOffert
            ).length
            return nb
        },
        AfficherDelaiExpedition() {
            if (
                this.paniervendeur.LignesPaniers.find(
                    (x) => x.Corner.Reference == 3
                )
            ) {
                return false
            }

            return true
        }
    },
    methods: {
        GetTransport() {
            const transport = this.paniervendeur.Transports.find(
                (t) => t.IsSelected
            )

            return transport
        },
        GetOption(referenceOption) {
            const option = this.panierVendeur.Options.find(
                (o) => o.Reference == referenceOption
            )

            return option
        },
        RedirectProduct(lignePanier) {
            window.location.href =
                window.location.origin + lignePanier.UrlFicheProduit
        }
    }
})
